import * as types from "./actionTypes";

export const setMiteredSections = (miteredSections) => ({
  type: types.SET_MITERED_SECTIONS,
  payload: {miteredSections}
});

export const addMiteredSection = (miteredSection) => ({
  type: types.ADD_MITERED_SECTION,
  payload: miteredSection
});

export const changeMiteredSection = (miteredSection) => ({
  type: types.CHANGE_MITERED_SECTION,
  payload: miteredSection
});

export const deleteMiteredSection = (id) => ({
  type: types.DELETE_MITERED_SECTION,
  payload: {id}
});

export const deleteAllMiteredSections = () => ({
  type: types.DELETE_ALL_MITERED_SECTIONS,
  payload: {}
});
